<div id="analytics-container" *loading="loadStatus">
  <ng-container *ngIf="annotations">
      <annotation-stat-item  *ngFor="let annotation of annotations" [data]="getAnnotationData(annotation)"></annotation-stat-item>
  </ng-container>
</div>
